import React, { useEffect, useState } from 'react';
import { pollGameUpdateStatus } from './components/services/game-update-service';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import NavMenu from './components/Navigation/NavMenu';
import GameUpdateScreen from './components/GameUpdateScreen';
import InstallPrompt from './components/UI/InstallPrompt';
import OfflineBanner from './components/UI/OfflineBanner';
import UpdateToast from './components/UI/UpdateToast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { onServiceWorkerUpdate } from './serviceWorkerUpdates';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});


function App() {
  const [swRegistration, setSwRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    pollGameUpdateStatus();
  }, []); // Empty dependency array = only run once on startup

  useEffect(() => onServiceWorkerUpdate(setSwRegistration), []);

  return (
    <div className='bg-app min-h-dvh'>
      <QueryClientProvider client={queryClient}>
        <Router>
          <OfflineBanner />
          <NavMenu />
          <GameUpdateScreen />
          <InstallPrompt />
          <UpdateToast registration={swRegistration} />
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </div>
  );
}

export default App;
